import React, { useEffect, useRef, useState } from 'react';
import "../employee/styleEmployeeFrom.css"
import "./styleEmployeeFrom.css"
import profile from "../../../assets/images/profile.png";
import { useDispatch, useSelector } from 'react-redux';
import { setAddEmp, setAllEmployee } from '../../../erpStore/actions';
import axios from 'axios';
import Select from "react-select";
import { toast } from 'react-toastify';
import Multiselect from 'multiselect-react-dropdown';
import { useNavigate } from 'react-router-dom';
import { Calendar } from "primereact/calendar";
import moment from 'moment'


export default function EmployeeForm(props) {
    const dispatch = useDispatch();
    const apiUrl = useSelector((state) => state.data.apiUrl)
    const stringHeaders = window.localStorage.getItem('myHeaders')
    const storedHeaders = JSON.parse(stringHeaders);
    const [department, setDepartment] = useState();
    const [departmentName, setDepartmentName] = useState()
    const [departmentList, setDepList] = useState();
    const [designation, setDesignation] = useState();
    const [designationList, setDesignationList] = useState();
    const [role, setRole] = useState();
    const [roleList, setRoleList] = useState();
    const [authority, setAuthority] = useState();
    const [authorityList, setAuthorityList] = useState();
    const selfInfo = useSelector((state) => state.data.selfData)
    const [submitError, setSubmitError] = useState(false)
    const [isemail, setIsEmail] = useState(true)
    const [isEmail2, setIsEmail2] = useState(true)
    const allEmployee = useSelector((state) => state.data.allEmployee)
    const navigate = useNavigate()

    const [joiningDateFlag, setJoiningDateFlag] = useState(false)
    const [joiningDate, setJoiningDate] = useState(null)
    const joiningDateRef = useRef(null)

    const [cardId, setCardId] = useState('')

    const [errorMsg, setErrorMsg] = useState(false)

    const [loader, setLoader] = useState(false);
    const [empObj, setEmpObj] = useState(
        {
            userId: '',
            empFullName: "",
            empStatus: "ACTIVE",
            designation: {
                designationId: ""
            },
            department: {
                departmentId: ""
            },
            role: [
                {
                    roleId: ""
                }
            ],
            reportingAuthorities: [],
            empEmailPersonal: "",
            empEmailOfficial: "",
            empMobile1: "",
            empOfficeLocation: "Pune",
            empJoiningDate: ""
        }

    );

    useEffect(() => {
        axios.get(`${apiUrl}employee/department/get/all`, {
            headers: storedHeaders
        })
            .then((response) => {
                setDepartment(response.data)
                const modifiedDeptList = response.data.map(department => ({
                    value: parseInt(department.departmentId),
                    label: department.departmentName,
                    empId: parseInt(props.props.empId)
                }))
                setDepList(modifiedDeptList)
                axios.get(`${apiUrl}employee/get/userId`, {
                    headers: storedHeaders
                })
                    .then((response) => {
                        setEmpObj({
                            ...empObj,
                            userId: response.data,
                        })
                    })
                    .catch((error) => {})
            })
            .catch((error) => {})
        axios.get(`${apiUrl}employee/role/all`, {
            headers: storedHeaders
        })
            .then((response) => {
                const modifiedDeptList = response.data.map(role => ({
                    value: parseInt(role.roleId),
                    label: role.roleName,
                    empId: parseInt(props.props.empId)
                }))
                setRoleList(modifiedDeptList)
            })
    }, [])
    const handleDepartment = async (e) => {
        setEmpObj({
            ...empObj,
            department: {
                ...empObj.department,
                departmentId: e.value.toString(),
            },
        }, []);
        setDepartmentName(e)
        axios.get(`${apiUrl}employee/designation/all`, {
            headers: storedHeaders
        })
            .then(async (response) => {
                const modifiedDeptList = await response.data.map(designation => ({
                    value: parseInt(designation.designationId),
                    label: designation.designation,
                    empId: parseInt(props.props.empId)
                }))
                setDesignationList(modifiedDeptList)
                setDesignation(null)
            })
            .catch((error) => {
            })
        setAuthority([])
        if (empObj && empObj.role.length > 0 && empObj.role[0].roleId) {
            axios.get(`${apiUrl}employee/get/higher/authority?role=${empObj.role[0].roleId}&department=${e.label}`, {
                headers: storedHeaders
            })
                .then((response) => {
                    const modifiedAuthList = response.data.map(emp => ({
                        value: parseInt(emp.empId),
                        label: emp.empFullName,
                        empId: parseInt(props.props.empId),
                        key: emp.empFullName
                    }))
                    setAuthorityList(modifiedAuthList)
                    setAuthority([])
                })
                .catch((error) => {
                })
        }
    }
    const handleNameChange = (event) => {
        const inputValue = event.target.value;
        const alphabeticValue = inputValue.replace(/[^a-zA-Z ]/g, "");
        setEmpObj({
            ...empObj,
            empFullName: alphabeticValue,
        });
    };
    const handleDateChange = (e) => {
        setEmpObj({
            ...empObj,
            empJoiningDate: e.target.value,
        });
    }
    const handleDesignation = (e) => {
        setEmpObj({
            ...empObj,
            designation: {
                ...empObj.designation,
                designationId: e.value.toString(),
            },
        });
        setDesignation(e)
    }
    const handleRoleChange = (e) => {
        let rl = [];
        for (let i = 0; i < e.length; i++) {
            rl.push({ roleId: e[i].value });
        }
        setEmpObj({
            ...empObj,
            role: [{
                roleId: e.value,
            }]
        });
        setRole(e)
        setAuthority([])
        if (departmentName && departmentName.label) {
            axios.get(`${apiUrl}employee/get/higher/authority?role=${e.value}&department=${departmentName.label}`, {
                headers: storedHeaders
            })
                .then((response) => {
                    const modifiedAuthList = response.data.map(emp => ({
                        value: parseInt(emp.empId),
                        label: emp.empFullName,
                        empId: parseInt(props.props.empId),
                        key: emp.empFullName
                    }))
                    setAuthorityList(modifiedAuthList)
                    setAuthority(null)
                })
                .catch((error) => {
                })
        } else {
            toast.error("Please Select Department", { toastId: 'error', autoClose: 2000 });
        }
    }
    const handleUserId = (e) => {
        setEmpObj({
            ...empObj,
            userId: e.target.value
        })
    }

    function validateIndianPhoneNumber(phoneNumber) {
        var phonePattern = /^[6-9]\d{9}$/;

        return phonePattern.test(phoneNumber);
    }

    const handleAuthority = (e) => {
        let auth = [];
        for (let i = 0; i < e.length; i++) {
            auth.push({ empId: e[i].value });
        }
        setEmpObj({
            ...empObj,
            reportingAuthorities: auth
        });
    }
    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }
    const submitForm = () => {
        // Validate each field
        if (empObj.empFullName === "") {
            setSubmitError(true)
            toast.error("Enter Employee FullName", { toastId: 'error', autoClose: 2000 });
            return
        }

        if (cardId === '') {
            toast.error("Please Enter RFID card number", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }

        if (empObj.userId === "") {
            toast.error("Enter Employee User Id", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        if (empObj.empJoiningDate === "" || empObj.empJoiningDate === null) {
            setErrorMsg(true)
            toast.error("Please select employee joining date", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        if (empObj.department.departmentId === '') {
            toast.error("Please select employee Department", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        if (!designation || empObj.designation.designationId === '') {
            toast.error("Please select employee Designation", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        if (empObj.role && empObj.role[0].roleId !== "") {

        }
        else {
            toast.error("Please select employee Role", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        if (empObj.role[0].roleId !== 1 && empObj.reportingAuthorities.length <= 0) {
            toast.error("Please select Higher Authorities", { toastId: 'error', autoClose: 2000 });
            setSubmitError(true)
            return
        }

        if (!validateIndianPhoneNumber(empObj.empMobile1)) {
            setSubmitError(true)
            toast.warning("Phone Number is Invalid", { toastId: 'warning', autoClose: 2000 });
            return
        }
        if (!validateEmail(empObj.empEmailPersonal)) {
            toast.error("Please Enter Valid Email", { toastId: 'warning', autoClose: 2000 });
            setSubmitError(true)
            setIsEmail(false)
            return
        }
        if (!validateEmail(empObj.empEmailOfficial)) {
            if (empObj.empEmailOfficial === '') {

            } else {
                toast.error("Please Enter Valid Email", { toastId: 'warning', autoClose: 2000 });
                setSubmitError(true)
                setIsEmail2(false)
                return
            }
        }
        if (empObj.empOfficeLocation === "") {
            toast.warning("Please Enter Valid Office Location", { toastId: 'warning', autoClose: 2000 });
            setSubmitError(true)
            return
        }
        setLoader(true)
        axios.post(`${apiUrl}employee/add`, empObj, {
            headers: storedHeaders
        })
            .then((response) => {
                if (response.request.status === 201) {
                    dispatch(setAddEmp(false));
                    dispatch(setAllEmployee([...allEmployee, response.data]))
                    toast.success("Employee Successfully Added", { toastId: 'Success', autoClose: 2000 });
                    setLoader(false)
                }

            })
            .catch((error) => {
                setLoader(false)
                if (error.response.status === 409) {
                    toast.error(error.response.data.message, { autoClose: 2000 })
                }
                if (error.response.status === 400) {
                    toast.error("Feild are missing", { autoClose: 2000 })
                }
                if (error.response.status === 500) {
                    navigate("/server-error")
                }
            })
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid blue' : '1px solid #ced4da', // Border color changes when focused
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : null, // Box shadow changes when focused
            '&:hover': {
                border: state.isFocused ? '1px solid blue' : '1px solid #ced4da', // Border color changes when hovered
            }
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: 'red' // Placeholder color
        })
    };

    useEffect(() => {
        function handleOutsideClick(event) {
            if (joiningDateRef && joiningDateRef.current && !joiningDateRef.current.contains(event.target)) {
                setJoiningDateFlag(false)
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick)
        }
    }, [])

    return (
        <div className="EmployeeFrom active">
            <div className='employeefom-container active'>
                <div className='dash-header'>
                    <div className='dash-header-container'>
                        <div className='dashHead-left-content'>
                            <svg onClick={() => {
                                dispatch(setAddEmp(false));
                            }} width="22" height="22" style={{ marginLeft: '15px' }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
                            </svg>
                        </div>
                        <div className='dashHead-right-content active'>
                            <img className='profileImg' src={selfInfo.empImg ? selfInfo.empImg : profile} alt='/' />
                            <p className='profileName'>{selfInfo.empFullName}</p>
                            <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='empHeader'>New Employee</div>
                <div className='emp-form'>
                    <div className='emp-info-slot1'>
                        <label>*Enter Full Name</label>
                        <input value={empObj.empFullName} style={{ border: submitError && empObj.empFullName === "" ? "1px solid red" : "" }} onChange={handleNameChange} type='text' />
                    </div>
                    <div className='emp-info-slot2'>
                        <div className='slot-part'>
                            <label>*User Id</label>
                            <input value={empObj.userId} style={{ border: submitError && empObj.userId === "" ? "1px solid red" : "" }} onChange={handleUserId} type='text'></input>
                        </div>
                        <div className='slot-part'>
                            <label>*Date of Joining</label>
                            {/* <input type='date' value={empObj.empJoiningDate} style={{ border: submitError && empObj.empJoiningDate === "" ? "1px solid red" : "" }} onChange={handleDateChange}></input> */}
                            <div className='taskEdtSelectDateForAdd addEmpJoininCal' style={{ border: submitError && (!empObj.empJoiningDate || empObj.empJoiningDate === '') ? '1px solid red' : null }} onClick={() => { setJoiningDateFlag(true) }}>
                                <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{joiningDate === null ? 'yyyy-mm-dd' : joiningDate}</p>
                                <div className='taskEdtSelectDateIcon'>
                                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                                        <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                                        <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                                    </svg>
                                </div>
                                {joiningDateFlag ?
                                    <div className='calender-holder-dashboard  cal-add-emp-join' ref={joiningDateRef}>
                                        <Calendar value={empObj.empJoiningDate === '' ? 'yyyy-mm-dd' : moment(empObj.empJoiningDate).toDate()} inline onChange={(e) => {
                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                                            setJoiningDate(formattedDate)
                                            setEmpObj({
                                                ...empObj,
                                                empJoiningDate: formattedDate,
                                            });
                                        }} unstyled={false} />
                                    </div> : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className='emp-info-slot2'>
                        <div className='slot-part'>
                            <label>*Department</label>
                            <Select options={departmentList} style={{ border: submitError && empObj.department.departmentId === "" ? "1px solid red" : "" }} placeholder="Select Department" value={departmentName} onChange={handleDepartment} isSearchable={true} isMulti={false} className={`empForm-select ${submitError && empObj.department.departmentId === '' ? 'redfeild' : ''}`} />
                        </div>
                        <div className='slot-part'>
                            <label>*Designation</label>
                            <Select options={designationList} placeholder="Select Designation" value={designation} onChange={handleDesignation} isSearchable={true} isMulti={false} className={`empForm-select ${submitError && (!designation || (!empObj.designation || !empObj.designation.designationId || empObj.designation.designationId === '')) ? 'redfeild' : ''}`} />
                        </div>
                    </div>
                    <div className='emp-info-slot2'>
                        <div className='slot-part'>
                            <label>*Role</label>
                            <Select options={roleList} styles={{ customStyles }} placeholder="Select Role" value={role} isSearchable={true} onChange={handleRoleChange} isMulti={false} className={`empForm-select ${submitError && empObj.role[0].roleId === '' ? 'redfeild' : ''}`} />
                        </div>

                        <div className='slot-part'>
                            <label>*Enter RFId Card Number</label>
                            <input value={cardId} style={{ border: submitError && cardId === "" ? "1px solid red" : "" }} onChange={(e) => {
                                setCardId(e.target.value)
                                setIsEmail2(true)
                                setEmpObj({
                                    ...empObj,
                                    ['cardId']: e.target.value
                                })
                            }} type='email'></input>
                        </div>

                    </div>
                    <div className='emp-info-slot1'>
                        <label>*Reporting Authority</label>
                        {/* <Select options={authorityList} styles={{
                            menu: (provided, state) => ({
                                ...provided,
                                border: submitError && empObj.reportingAuthorities.length < 1 ? '1px solid #ccc' : null, // Adjust border style as needed
                            }),
                        }} placeholder="Select Authority" value={authority} onChange={handleAuthority} isSearchable={true} isMulti={true} className='empForm-select' /> */}
                        <Multiselect
                            displayValue="key"
                            onKeyPressFn={function noRefCheck() { }}
                            onRemove={(e) => handleAuthority(e)}
                            onSearch={function noRefCheck() { }}
                            onSelect={(e) => handleAuthority(e)}
                            options={authorityList}
                            selectedValues={authority}
                            placeholder=''
                            disable={empObj.role[0].roleId !== 1 ? false : true}
                            id="css_custom"
                            style={{
                                chips: {
                                    background: 'red'
                                },
                                searchBox: {
                                    border: submitError && (empObj.reportingAuthorities.length === 0) ? '1px solid red' : "1px solid #5a5959",
                                },
                            }}
                        />
                    </div>
                    <div className='emp-info-slot2'>
                        <div className='slot-part'>
                            <label>*Enter Mobile no</label>
                            <input type='number' value={empObj.empMobile1} style={{ border: submitError || (empObj.empMobile1 || empObj.empMobile1.length < 10) === "" ? "1px solid red" : "" }} onChange={(e) => {
                                if (e.target.value.length > 10) {
                                    return
                                }
                                setEmpObj({
                                    ...empObj,
                                    empMobile1: e.target.value
                                })
                            }} minLength={10} maxLength={10}></input>
                        </div>
                        <div className='slot-part'>
                            <label>*Enter personal E-mail Id</label>
                            <input value={empObj.empEmailPersonal} style={{ border: (submitError || !isemail) && (!empObj.empEmailPersonal || empObj.empEmailPersonal === "") ? "1px solid red" : "" }} onChange={(e) => {
                                setEmpObj({
                                    ...empObj,
                                    empEmailPersonal: e.target.value
                                })
                            }} type='email'></input>
                        </div>
                    </div>
                    <div className='emp-info-slot2'>
                        <div className='slot-part'>
                            <label>Enter Official E-mail Id</label>
                            <input value={empObj.empEmailOfficial} style={{ border: (submitError && !isEmail2) ? "1px solid red" : "" }} onChange={(e) => {
                                setIsEmail2(true)
                                setEmpObj({
                                    ...empObj,
                                    empEmailOfficial: e.target.value
                                })
                            }} type='email'></input>
                        </div>
                    </div>

                    <div className='emp-info-slot1'>
                        <label>*Office Location</label>
                        <input value={empObj.empOfficeLocation} style={{ border: submitError && empObj.empOfficeLocation === "" ? "1px solid red" : "" }} onChange={(e) => {
                            setEmpObj({
                                ...empObj,
                                empOfficeLocation: e.target.value
                            })
                        }} type='text' />
                    </div>
                </div>
                <div className='form-bottom-buttons'>
                    <div className='AddEmpButtonEmpty' onClick={!loader ? submitForm : null}>{
                        loader ? <div className='add-emp-loader' /> : "Add Employees"}</div>
                    <div className='cancelBtn' onClick={() => dispatch(setAddEmp(false))}>Cancel</div>
                </div>
            </div>
        </div >
    )
}
